import {ContactDto} from '../services/messages/ContactDto';
import {EnrichedDavContact} from "../services/messages/VCardContactData";

export interface ContactState {
    contacts: ContactDto[];

    davContacts: EnrichedDavContact[];

    contactSearchText: string;

    contactLookupMap: Map<string, EnrichedDavContact>;
}

export const initialContactState: ContactState = {
    contacts: [],
    davContacts: [],

    contactSearchText: "",

    contactLookupMap: new Map<string, EnrichedDavContact>(),
};
